import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconAnchor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAnchor"><Circle cx="12" cy="6.5" r="2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><Path d="M12 9.25V16.125C12 18.4032 13.8468 20.25 16.125 20.25C18.4032 20.25 20.25 18.4032 20.25 16.125V13L18 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><Path d="M12 9.25V16.125C12 18.4032 10.1532 20.25 7.875 20.25C5.59683 20.25 3.75 18.4032 3.75 16.125V13L6 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAnchor;
